export const POST_GRID_CARD_FOOTER_HEIGHT = 40;

export const MENU_TRIGGER_SIZE = 16;

export const AVATAR_SIZE = 24;

export const POST_COLLECTION_GRID_CARD_RATIO = 3 / 4;
